const API_BASE = process.env.REACT_APP_API_URL || '/api/v1';

function getToken() {
  return localStorage.getItem('token');
}

async function request(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    return;
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'Ошибка сервера');
  return data;
}

const api = {
  // Веб-авторизация
  register: (flat_number, invite_code, password, email) =>
    request('/auth/web/register', {
      method: 'POST',
      body: JSON.stringify({ flat_number, invite_code, password, email }),
    }),

  loginMod: (display_name, password) =>
    request('/auth/web/mod/login', {
      method: 'POST',
      body: JSON.stringify({ display_name, password }),
    }),

  login: (flat_number, password) =>
    request('/auth/web/login', {
      method: 'POST',
      body: JSON.stringify({ flat_number, password }),
    }),

  resetRequest: (email) =>
    request('/auth/web/reset-password/request', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  resetConfirm: (token, new_password) =>
    request('/auth/web/reset-password/confirm', {
      method: 'POST',
      body: JSON.stringify({ token, new_password }),
    }),

  changePassword: (old_password, new_password) =>
    request('/auth/web/change-password', {
      method: 'POST',
      body: JSON.stringify({ old_password, new_password }),
    }),

  removeEmail: () =>
    request('/auth/web/remove-email', { method: 'POST' }),

  changeEmail: (email, password) =>
    request('/auth/web/change-email', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  // Профиль
  me: () => request('/auth/me'),

  // Показания
  flatMeters: (flat) => request(`/readings/flat/${flat}/meters`),
  history: (flat, limit = 6) => request(`/readings/history/${flat}?limit=${limit}`),
  statistics: (flat, months = 6) => request(`/readings/statistics/${flat}?months=${months}`),
  submit: (flat_number, meters) =>
    request('/readings/submit', {
      method: 'POST',
      body: JSON.stringify({ flat_number, meters, source: 'web' }),
    }),

  // Заявления об отсутствии
  absencesMy: () => request('/absences/my'),
  absenceCreate: (flat_number, from_year, from_month, to_year, to_month) =>
    request(`/absences/?flat_number=${flat_number}&from_year=${from_year}&from_month=${from_month}&to_year=${to_year}&to_month=${to_month}`, {
      method: 'POST',
    }),
  absenceCancel: (id) =>
    request(`/absences/${id}/cancel`, { method: 'POST' }),

  // Админ
  adminStatus: () => request('/admin/status'),
  adminUnsubmitted: () => request('/admin/status'),
  adminSuspicious: () => request('/admin/suspicious'),
  adminWhoSubmits: () => request('/admin/who-submits'),
  adminInviteCodes: () => request('/admin/invite-codes'),
  adminCreateInvite: (flat_number) =>
    request('/auth/invite/create', {
      method: 'POST',
      body: JSON.stringify({ flat_number, expires_days: 7 }),
    }),
  adminFlatUsers: (flat) => request(`/admin/flat/${flat}/users`),
  adminUnlinkUser: (flat_user_id) =>
    request(`/admin/flat-user/${flat_user_id}`, { method: 'DELETE' }),
  adminAbsences: () => request('/absences/admin/all'),
  adminListAdmins: () => request('/admin/admins'),
  adminAllFlats: () => request('/admin/flats/all'),

  // Общедомовой счётчик
  houseSubmit: (year, month, value) =>
    request('/house/submit', {
      method: 'POST',
      body: JSON.stringify({ year, month, value }),
    }),
  houseHistory: (limit = 12) => request(`/house/history?limit=${limit}`),
  houseCurrentMonth: () => request('/house/current-month'),
  houseFlatAvg: (flat_number) => request(`/house/flat-avg/${flat_number}`),
  houseStatistics: (months = 12) => request(`/house/statistics?months=${months}`),
  houseCurrentDiff: () => request('/house/current-diff'),
  adminFlatInviteCodes: (flat_number) => request(`/admin/invite-codes/flat/${flat_number}`),
  adminBulkInvite: (flat_numbers) =>
    request('/admin/invite-codes/bulk', {
      method: 'POST',
      body: JSON.stringify(flat_numbers),
    }),

  adminModeratorInvite: () =>
    request('/admin/moderator-invite', { method: 'POST' }),

  adminPromote: (flat_number) =>
    request(`/admin/admins/promote?flat_number=${flat_number}`, { method: 'POST' }),
  adminDeleteAdmin: (user_id) =>
    request(`/admin/admins/${user_id}`, { method: 'DELETE' }),

  adminCreateAdmin: (display_name, email) =>
    request('/admin/create-admin', {
      method: 'POST',
      body: JSON.stringify({ display_name, email }),
    }),
  adminExportExcel: (year, month) =>
    fetch(`${API_BASE}/admin/export/excel?year=${year}&month=${month}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    }),
};

export default api;
